import React from 'react';
import dayjs from 'dayjs';
import _ from 'lodash';

const ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss";

function FormDateTimeDisplayField({ value, dateFormat, dateSeparator, timeFormat = "hh:mm:ss a", ...field }) {
    const format = `${_.replace(dateFormat, /\$/g, dateSeparator)} ${timeFormat}`;
    let dateTimeValue = value && dayjs(value, ISO_FORMAT);
    if (dateTimeValue) {
        if (dateTimeValue.isValid() === false) {
            dateTimeValue = value;
        }
        else {
            dateTimeValue = dateTimeValue.format(format);
        }
    }
    return <>{dateTimeValue}</>;
}

export default FormDateTimeDisplayField